<app-traitement-data titre="AI MIN - AI MAX" [sousTitre]="patient!.tableauDeBord?.aiMin?.date | aLaDateDu"
    statut="info">
    {{ patient!.tableauDeBord?.aiMin?.value ?? 'Ø' }} - {{ patient!.tableauDeBord?.aiMax?.value ?? 'Ø' }}
</app-traitement-data>